<div #rating class="rating">
  <span>{{ value }}</span>
</div>
